import React, { useState, useEffect, useRef } from 'react';
import { Tabs, Table, Button, Form, Input, Spin, Space, Popover } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, HomeOutlined, SearchOutlined, RedoOutlined, PlusCircleOutlined, EditOutlined, DeleteOutlined, EyeOutlined, UploadOutlined } from '@ant-design/icons';
import Message from '../../component/message/message';
import moment from 'moment';//日期格式化导包
import PopupFrame from '../../component/popupFrame/popupFrame';
import Audit from '../../component/audit/audit';//审核彈框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import trans from './translation';
import './formSetup.css';
const ClassicEditor = window.ClassicEditor;
const { TabPane } = Tabs;
const { TextArea } = Input;
const Cohort = (props) => {
    const [form] = Form.useForm();
    const [form2] = Form.useForm();

    const messageRef = useRef();
    const [tabIndex, setTabIndex] = useState("1");
    const [checkboxState, setCheckboxState] = useState([]);
    const [flag, setFlag] = useState("add");
    const [isAudit, setIsAudit] = useState(false);
    const [isDeleteFrame, setIsDeleteFrame] = useState(false);
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [auditModel, setAuditModel] = useState({});

    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isLeave, setIsLeave] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isUpload, setIsUpload] = useState(false);
    const [formSetupModel, setFormSetupModel] = useState({});
    const [deleteTipText, setDeleteTipText] = useState("");
    const [ckeditorEN, setCkeditorEN] = useState(null);
    const [ckeditorTC, setCkeditorTC] = useState(null);
    const [ckeditorSC, setCkeditorSC] = useState(null);

    const tableColumns = {
        formSetup: "formSetup",
    }

    useEffect(() => {
        search(pageSize, 1, "N");
        ClassicEditor.create(document.querySelector('#editorEN'), Config.ckEditorConfig)
        .then(editor => {
            setCkeditorEN(editor);
        }).catch(error => { console.log(error) });
        ClassicEditor.create(document.querySelector('#editorTC'), Config.ckEditorConfig)
        .then(editor => {
            setCkeditorTC(editor);
        }).catch(error => { console.log(error) });
        ClassicEditor.create(document.querySelector('#editorSC'), Config.ckEditorConfig)
        .then(editor => {
            setCkeditorSC(editor);
        }).catch(error => { console.log(error) });
    }, []);

    const search = (pageSizeNew, currentPageNew, flag, isShowMsg) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();  // 清除提示信息
        let model = {};
        if ("Y" === flag) {     // 翻页
            model = oldSearchModel;
        } else if ("reset" === flag) {
            model = {}
        } else {
            model = searchModel;
        }
        model.page = currentPageNew;
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("formSetup/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data?.object?.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const searchChange = (key, value) => {
        messageShowHandler();
        setSearchModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }

    const reset = () => {
        messageShowHandler();
        form2.resetFields();
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
        setSearchModel({})
    }


    // Tab页切换
    const handleSelect = (key) => {
        if (key) {
            if (key === "2") {
                if (Config.funcInfo.canInsert === "Y") {
                    add();
                }
            } else if (tabIndex !== "1") {
                setTabIndex("1");
                search(pageSize, current, "Y");
            }
        }
    }

    const add = () => {
        messageShowHandler();
        initForm({});
        setFlag("add");
        setTabIndex("2");
        ckeditorEN.setData('');
        ckeditorTC.setData('');
        ckeditorSC.setData('');
    }
    const download = () => {
        setIsUpload(true)
    }

    const update = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        messageShowHandler();
        searchById(model.formSetupId)
        setTabIndex("2");
        setFlag("edit");
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            code: model.code ?? '',
            contentEn: model.contentEn ?? '',
            contentTc: model.contentTc ?? '',
            contentSc: model.contentSc ?? '',
            description: model.description ?? '',
        });
    }

    const deleteFrameClose = (state) => {
        if (state) {
            deleteData();
        }
        setIsDeleteFrame(false);
    }

    const deleteData = () => {
        setIsLoad(true);
        setSpinInfo(trans.deleteData[Config.backLang]);
        let deleteModel = formSetupModel;
        deleteModel.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi("formSetup/delete", deleteModel).then((data) => {
            if ("SUCCESS" === data.msg) {
                cancel();
                search(pageSize, current, "Y", false);
                errFrameShow("success", trans.deleteSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const audit = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        setAuditModel(model);
        setIsAudit(true);
    }

    const auditCancel = () => {
        setIsAudit(false);
    }

    const onFinish = (values) => {
        messageShowHandler();
        setIsLoad(true);
        setSpinInfo(trans.dataBeSaving[Config.backLang])
        let contentEN = ckeditorEN.getData();
        if(contentEN) {
            var tempDiv1 = document.createElement('div');
            tempDiv1.innerHTML = contentEN;
            var images1 = tempDiv1.getElementsByTagName('img');
            for (var i1 = 0; i1 < images1.length; i1++) {
                var img1 = images1[i1];
                var src1 = img1.getAttribute('src');
                var index1 = src1.indexOf('?sv=');
                if (index1 !== -1) {
                    var newSrc1 = src1.substring(0, index1);
                    img1.setAttribute('src', newSrc1);
                }
            }
            values.contentEn = tempDiv1.innerHTML;
        } else{
            errFrameShow("error", trans.contentEN[Config.backLang] + " is required.");
            setIsLoad(false);
            return;
        }
        let contentTC = ckeditorTC.getData();
        if(contentTC) {
            var tempDiv2 = document.createElement('div');
            tempDiv2.innerHTML = contentTC;
            var images2 = tempDiv2.getElementsByTagName('img');
            for (var i2 = 0; i2 < images2.length; i2++) {
                var img2 = images2[i2];
                var src2 = img2.getAttribute('src');
                var index2 = src2.indexOf('?sv=');
                if (index2 !== -1) {
                    var newSrc2 = src2.substring(0, index2);
                    img2.setAttribute('src', newSrc2);
                }
            }
            values.contentTc = tempDiv2.innerHTML;
        } else {
            errFrameShow("error", trans.contentTC[Config.backLang] + " is required.");
            setIsLoad(false);
            return;
        }
        let contentSC = ckeditorSC.getData();
        if(contentSC) {
            var tempDiv3 = document.createElement('div');
            tempDiv3.innerHTML = contentSC;
            var images3 = tempDiv3.getElementsByTagName('img');
            for (var i3 = 0; i3 < images3.length; i3++) {
                var img3 = images3[i3];
                var src3 = img3.getAttribute('src');
                var index3 = src3.indexOf('?sv=');
                if (index3 !== -1) {
                    var newSrc3 = src3.substring(0, index3);
                    img3.setAttribute('src', newSrc3);
                }
            }
            values.contentSc = tempDiv3.innerHTML;
        } else {
            errFrameShow("error", trans.contentSC[Config.backLang] + " is required.");
            setIsLoad(false);
            return;
        }
        let url = "";
        if (flag === "add") {
            url = "formSetup/insert";
        } else {
            url = "formSetup/update"
            values.formSetupId = formSetupModel.formSetupId;
            values.lastUpdatedDate = formSetupModel.lastUpdatedDate;
        }
        values.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi(url, values).then((data) => {
            if ("SUCCESS" === data.msg) {
                searchById(data.object)
                errFrameShow("success", trans.saveSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => {
            setIsLoad(false);
        });
    }

    const searchById = (model) => {
        setIsLoading(true);
        Base.callBackApi("formSetup/searchById", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                let formSetupModel = data.object;
                initForm(formSetupModel);
                setFormSetupModel(formSetupModel)
                setFlag("edit");
                let contentEn;
                if(formSetupModel.contentEn) {
                    var tempDivE = document.createElement('div');
                    tempDivE.innerHTML = formSetupModel.contentEn;
                    var images1 = tempDivE.getElementsByTagName('img');
                    for (var i1 = 0; i1 < images1.length; i1++) {
                        var img1 = images1[i1];
                        var src1 = img1.getAttribute('src');
                        var index1 = src1.indexOf(Config.imgServer);
                        if (index1 !== -1) {
                            var newSrc1 = src1 + '?' + Config.sasToken;
                            img1.setAttribute('src', newSrc1);
                        }
                    }
                    contentEn = tempDivE.innerHTML;
                }
                ckeditorEN.setData(contentEn);
                let contentSc;
                if(formSetupModel.contentSc) {
                    var tempDivS = document.createElement('div');
                    tempDivS.innerHTML = formSetupModel.contentSc;
                    var images2 = tempDivS.getElementsByTagName('img');
                    for (var i2 = 0; i2 < images2.length; i2++) {
                        var img2 = images2[i2];
                        var src2 = img2.getAttribute('src');
                        var index2 = src2.indexOf(Config.imgServer);
                        if (index2 !== -1) {
                            var newSrc2 = src2 + '?' + Config.sasToken;
                            img2.setAttribute('src', newSrc2);
                        }
                    }
                    contentSc = tempDivS.innerHTML;
                }
                ckeditorSC.setData(contentSc);
                let contentTc;
                if(formSetupModel.contentTc) {
                    var tempDivT = document.createElement('div');
                    tempDivT.innerHTML = formSetupModel.contentTc;
                    var images3 = tempDivT.getElementsByTagName('img');
                    for (var i3 = 0; i3 < images3.length; i3++) {
                        var img3 = images3[i3];
                        var src3 = img3.getAttribute('src');
                        var index3 = src3.indexOf(Config.imgServer);
                        if (index3 !== -1) {
                            var newSrc3 = src3 + '?' + Config.sasToken;
                            img3.setAttribute('src', newSrc3);
                        }
                    }
                    contentTc = tempDivT.innerHTML;
                }
                ckeditorTC.setData(contentTc);
            } else {
                this.errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoading(false));
    }

    const cancel = () => {
        messageShowHandler();
        setTabIndex("1");
        ckeditorEN.setData('');
        ckeditorSC.setData('');
        ckeditorTC.setData('');
        search(pageSize, current, "Y");
    }

    const leaveFrameClose = (state) => {
        if (state) {
            cancel();
        }
        setIsLeave(false);
    }

    const deleteOne = (model, e, type) => {
        e.stopPropagation();
        setFormSetupModel(model)
        setIsDeleteFrame(true);
        setDeleteTipText("code" + ":" + model.code + "")
    }


    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }


    /*eslint-disable*/
    const columns = [

        {
            title: 'Code',
            dataIndex: 'code',
            className: 'tableWidth30',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'formSetup') },
        },
        {
            title: 'Description',
            dataIndex: 'description',
            className: 'tableWidth70',
            render: (text) => <Popover content={text} title="" trigger="hover">
                <div className = "operationLogManageContent">{text}</div>
            </Popover>
        },
        {
            title: trans.controls[Config.backLang],
            dataIndex: '',
            className: ' sysControls',
            fixed: 'right',
            width: 206,
            render: (text, record) => <div className='operation'>
                <div className='sysUpdate' onClick={(e) => update(record, e)} hidden={Config.funcInfo.canUpdate === "N"}><EditOutlined /> {trans.update[Config.backLang]}</div>
                <div className='sysDelete' onClick={(e) => deleteOne(record, e, "segment")} hidden={Config.funcInfo.canDelete === "N"}><DeleteOutlined /> {trans.delete[Config.backLang]}</div>
                <div className='sysLogs' onClick={(e) => audit(record, e)}><EyeOutlined /> {trans.audit[Config.backLang]}</div>
            </div>
        },
    ];

    return (
        <div id="container" className="template formSetup">
            <div className='breadcrumb'>
                <HomeOutlined /> / Admin / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : '')]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                <Spin size="large" spinning={isLoad} tip={spinInfo}>
                    {/* 删除弹框 */}
                    {isDeleteFrame ? <PopupFrame close={deleteFrameClose} deleteTipText={deleteTipText} /> : null}
                    {isLeave ? <PopupFrame close={leaveFrameClose} type='leave' /> : null}
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                    <Tabs activeKey={tabIndex} onChange={(e) => handleSelect(e)}>
                        <TabPane key="1" tab={trans.list[Config.backLang]}>
                            <Form form={form2} >
                                <div className='sysSearchRow sysSearchBox'>
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysTitle">{trans.code[Config.backLang]}</div>
                                            <div className="sysSerchInput">
                                                <Form.Item
                                                    name="code"
                                                >
                                                    <Input type="text" placeholder={trans.code[Config.backLang]} value={searchModel.code || ''}
                                                        onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                        onChange={(e) => searchChange('code', e.target.value)} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysSearchButton'>
                                            <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                            <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                                        </div>
                                    </div>
                                </div>
                            </Form>
                            <div className="sysLineEight"></div>
                            <Space size={[5, 5]} wrap className="sysButtonRelative">
                                <Button type="primary" className="sysBtn btnBlue" onClick={add} hidden={Config.funcInfo.canInsert === "N"} icon={<PlusCircleOutlined />}>{trans.add[Config.backLang]}</Button>
                            </Space>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    scroll={{ x: 800 }}
                                    rowKey="formSetupId" //Key值
                                    columns={columns} //列名
                                    dataSource={tables} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                                        onChange: onChange,                        //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChange,        //每页显示多少条数据方法
                                        total: tablesCount,             //总共多少条数据
                                        current: current,                //当前页
                                        pageSize: pageSize,              //每页显示多少条数据
                                        defaultCurrent: 1,                               //默认当前页为1
                                        size: "small"
                                    }}
                                    onChange={handleTableChange}
                                />
                            </div>
                        </TabPane>
                        <TabPane key="2" tab={trans.formSetup[Config.backLang]} forceRender={true}>
                            <Form form={form} onFinish={onFinish}>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.code[Config.backLang]}</div>
                                        <div className="sysInput ">
                                            <Form.Item
                                                name="code"
                                                rules={[
                                                    { required: true, message: trans.codeNoIsNull[Config.backLang] },
                                                ]}
                                                getValueFromEvent={(e) => Base.codeChange(e, 30)}
                                            >
                                                <Input type="text" placeholder={trans.code[Config.backLang]} maxLength={30}  disabled={flag === "edit"}/>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysColMax'>
                                        <div className="sysParam ">{trans.description[Config.backLang]}</div>
                                        <div className="sysInputs">
                                            <Form.Item
                                                name="description"
                                            >
                                                <TextArea className="textarea" placeholder={trans.description[Config.backLang]} maxLength={250} rows = {3}/>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.contentEN[Config.backLang]}</div>
                                        <div className="sysInputs editor">
                                            <div id="editorEN" className="editor"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.contentTC[Config.backLang]}</div>
                                        <div className="sysInputs editor">
                                            <div id="editorTC" className="editor"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.contentSC[Config.backLang]}</div>
                                        <div className="sysInputs editor">
                                            <div id="editorSC" className="editor"></div>
                                        </div>
                                    </div>
                                </div>
                                                                                                
                                <div className="sysSaveButton">
                                    <Button className="sysBtn btnBlue" type="primary" disabled={isLoad} icon={<CheckCircleOutlined />} htmlType="submit">{trans.save[Config.backLang]}</Button>
                                    <Button className="sysBtn" icon={<CloseCircleOutlined />} onClick={cancel}>{trans.cancel[Config.backLang]}</Button>
                                </div>
                            </Form>
                        </TabPane>
                    </Tabs>
                </Spin>
            </div>
        </div>
    )

}

export default Cohort;